import { createRoot } from "react-dom/client";

export const container = document.getElementById("root");
export const root = createRoot(container!);
